var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center mb-4"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('h2', {
    style: {
      color: '#fff',
      fontWeight: 'bold',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)'
    }
  }, [_vm._v(" " + _vm._s(_vm.tagline) + " ")])])]), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "card rounded-lg"
  }, [_c('b-row', {
    staticClass: "mt-2 ml-2"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "login-heading",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("createYourAccount")) + " ")])])]), _c('div', {
    staticClass: "card-body pl-5 pr-5"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('form', {
    staticClass: "mt-4 mb-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.otpInput1,
      expression: "otpInput1"
    }],
    ref: "otp1",
    staticClass: "otp border",
    attrs: {
      "type": "text",
      "maxlength": "1"
    },
    domProps: {
      "value": _vm.otpInput1
    },
    on: {
      "keyup": function ($event) {
        return $event.target.nextElementSibling.focus();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.otpInput1 = $event.target.value;
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.otpInput2,
      expression: "otpInput2"
    }],
    staticClass: "otp border",
    attrs: {
      "type": "text",
      "maxlength": "1"
    },
    domProps: {
      "value": _vm.otpInput2
    },
    on: {
      "keyup": function ($event) {
        return $event.target.nextElementSibling.focus();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.otpInput2 = $event.target.value;
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.otpInput3,
      expression: "otpInput3"
    }],
    staticClass: "otp border",
    attrs: {
      "type": "text",
      "maxlength": "1"
    },
    domProps: {
      "value": _vm.otpInput3
    },
    on: {
      "keyup": function ($event) {
        return $event.target.nextElementSibling.focus();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.otpInput3 = $event.target.value;
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.otpInput4,
      expression: "otpInput4"
    }],
    staticClass: "otp border",
    attrs: {
      "type": "text",
      "maxlength": "1"
    },
    domProps: {
      "value": _vm.otpInput4
    },
    on: {
      "keyup": function ($event) {
        return $event.target.nextElementSibling.focus();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.otpInput4 = $event.target.value;
      }
    }
  })]), _c('p', {
    style: {
      color: _vm.otpMsg.key
    }
  }, [_vm._v(" " + _vm._s(_vm.otpMsg.value) + " ")])])]), _c('div', {
    staticClass: "form-group pt-3 pb-2 text-center"
  }, [_c('b-button', {
    staticClass: "primary-btn",
    attrs: {
      "size": "lg"
    },
    on: {
      "click": function () {
        return _vm.loginOtp();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("verifyOTP")))])], 1), _c('div', {
    staticClass: "d-flex justify-content-center gap-3 mt-4"
  }, [_c('b-button', {
    staticClass: "circle-btn border",
    attrs: {
      "variant": "light"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/login?type=otp');
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "telephone-fill",
      "font-scale": "1.2"
    }
  })], 1), _c('b-button', {
    staticClass: "circle-btn border",
    attrs: {
      "variant": "light"
    },
    on: {
      "click": _vm.googleLogin
    }
  }, [_c('img', {
    staticClass: "icon-img",
    attrs: {
      "src": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg",
      "alt": "Google"
    }
  })]), _c('b-button', {
    staticClass: "circle-btn border",
    attrs: {
      "variant": "light"
    },
    on: {
      "click": _vm.facebookLogin
    }
  }, [_c('img', {
    staticClass: "icon-img",
    attrs: {
      "src": "https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png",
      "alt": "Facebook"
    }
  })])], 1)])], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }